import {CreateCounterparty, CounterpartyId} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function list() {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/counterparties`, {});
}

export async function get(counterpartyId: CounterpartyId) {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/counterparties/{counterparty_id}`,
    {path: {counterparty_id: counterpartyId}},
  );
}

export async function create(counterparty: CreateCounterparty) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/counterparties`, {
    body: counterparty,
  });
  await invalidateQueries([q.vendorToolkit.counterparties.filter()]);
  return res;
}

export async function updateName(counterpartyId: CounterpartyId, name: string) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/counterparties/{counterparty_id}/name`,
    {body: name, path: {counterparty_id: counterpartyId}},
  );
  await invalidateQueries([
    q.vendorToolkit.counterparties.filter(),
    q.vendorToolkit.counterparty.filter(counterpartyId),
  ]);
  return res;
}

export async function updateLanguageCode(counterpartyId: CounterpartyId, languageCode: string) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/counterparties/{counterparty_id}/language_code`,
    {body: languageCode, path: {counterparty_id: counterpartyId}},
  );
  await invalidateQueries([
    q.vendorToolkit.counterparties.filter(),
    q.vendorToolkit.counterparty.filter(counterpartyId),
  ]);
  return res;
}

export async function updateUrl(counterpartyId: CounterpartyId, url: string) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/counterparties/{counterparty_id}/url`,
    {body: url, path: {counterparty_id: counterpartyId}},
  );
  await invalidateQueries([
    q.vendorToolkit.counterparties.filter(),
    q.vendorToolkit.counterparty.filter(counterpartyId),
  ]);
  return res;
}
